/* Toernooi-format metadata — single source of truth voor:
   - Nederlandse labels (voor kaarten, dropdowns, badges)
   - Minimum-deelnemer-aantal per format
   - Uitleg-hint (voor picker en tooltips)
   - Best-of ondersteuning (deathmatch/ffa scoren zelf, best_of is n.v.t.)

   Voorheen zaten deze in TournamentsPage (formatType, formatTypeLabel) en
   TournamentDetailsPage (FORMAT_CHOICES). Drift-risico weg. */

export const TOURNAMENT_FORMATS = [
  { key: 'single_elimination', label: 'Single elimination',      min: 2, hint: 'Klassieke bracket, 1 verlies = uit.',        supportsBestOf: true  },
  { key: 'double_elimination', label: 'Double elimination',      min: 2, hint: 'Winners + losers bracket, 2e kans.',           supportsBestOf: true  },
  { key: 'round_robin',        label: 'Round robin',             min: 3, hint: 'Iedereen speelt tegen iedereen.',              supportsBestOf: true  },
  { key: 'swiss',              label: 'Swiss system',            min: 4, hint: 'Gepaird per ronde op resultaat.',              supportsBestOf: true  },
  { key: 'group_ko',           label: 'Group stage + knockout',  min: 4, hint: 'Poules → KO-fase.',                            supportsBestOf: true  },
  { key: 'ffa',                label: 'Free-for-all rondes',     min: 3, hint: 'Heats van 3–6 spelers.',                       supportsBestOf: false },
  { key: 'ladder',             label: 'Ladder (challenge queue)', min: 2, hint: 'Winnaar blijft, elke deelnemer 1 challenge in seed-orde.', supportsBestOf: true  },
  { key: 'consolation',        label: 'Consolation bracket',     min: 4, hint: 'Verliezers-ronde voor 3e/4e plaats.',          supportsBestOf: true  },
  { key: 'deathmatch',         label: 'Deathmatch (score-based)', min: 2, hint: 'Kills of punten, X rondes.',                  supportsBestOf: false },
]

const FORMAT_BY_KEY = Object.fromEntries(TOURNAMENT_FORMATS.map(f => [f.key, f]))

export function formatLabel(type) {
  if (!type || type === 'pending') return 'Format nog te kiezen'
  return FORMAT_BY_KEY[type]?.label
    || type.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
}

export function formatMinParticipants(type) {
  return FORMAT_BY_KEY[type]?.min || 2
}

export function supportsBestOf(type) {
  return FORMAT_BY_KEY[type]?.supportsBestOf ?? true
}
